// Create an angular service to call the positionstack API with a method to geocode a location string to a latitude and longitude.

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { environment } from "src/environments/environment";
import { RestService } from "./rest.service";
import { Feature as GeoJSONFeature } from "geojson";

// Create an interface to define the response from the API.


export interface GeocodeResponse {
    data: GeoJSONFeature[];
}

@Injectable({ providedIn: "root" })
export class GeocodeService extends RestService {
    constructor(protected http: HttpClient) {
        super(http);
        this.url = environment.api + '/geocode';
    }

    public geocode(location: string): Observable<GeoJSONFeature[]> {
        return this.get(`?location=${encodeURIComponent(location)}`).pipe(map((response: GeocodeResponse) => response.data));
    }

}
